/**
   * Cart Struct:
   * {
   *  producer: Mongo ID,
   *  products: [ ... ]
   * }
   */

const addProductToCart = (product) => {
  try {
    const cart = getCart();
    let newCart = {};

    // Check if is the same producer
    if (cart && product.producer !== cart.producer) {
      return -1;
    }

    if (cart) {

      // Search product in Cart
      const found = cart.products.find(p => p.id === product.id);

      if (found) {
        // Edit the product
        newCart = { ...cart };
        newCart.products.forEach(prod => {
          if (prod.id === product.id) {
            prod.pack = product.pack;
          }
        });
      } else {
        // Add new product to cart
        newCart = { ...cart };
        newCart.products.push(product);
      }
    } else {
      // Create new cart
      newCart = {
        producer: product.producer,
        producerName: product.producerName,
        producerSlug: product.producerSlug,
        products: [
          product
        ]
      }
    }

    const serializedCart = JSON.stringify(newCart);
    localStorage.setItem('__cart', serializedCart);
    return 0;
  } catch (error) {
    console.log(error);
  }
}

const removeOneProduct = (product) => {
  try {
    const cart = getCart();
    let newCart = {};

    if (cart) {
      // Search product in Cart
      const found = cart.products.find(p => p.id === product.id);

      if (found) {
        // Remove the product
        newCart = { ...cart };
        newCart.products.forEach((prod, index) => {
          if (prod.id === product.id) {
            newCart.products.splice(index, 1);
          }
        });
      }
    }

    const serializedCart = JSON.stringify(newCart);
    localStorage.setItem('__cart', serializedCart);
  } catch (error) {
    console.log(error);
  }
}

const getCart = () => {
  try {
    const serializedCart = localStorage.getItem('__cart');
    if (!serializedCart) return null;
    const deserializedCart = JSON.parse(serializedCart);
    return deserializedCart;
  } catch (error) {
    console.log(error);
  }
}

const emptyCart = () => {
  try {
    localStorage.removeItem('__cart');
  } catch (error) {
    console.log(error);
  }
}

export {
  addProductToCart,
  removeOneProduct,
  getCart,
  emptyCart,
};